import { createFileRoute, redirect } from '@tanstack/react-router';
import { ApplicationsPage } from '@/pages/Cabinet/Applications';
import { queryClient } from '@/app/providers/QueryProvider/client.ts';
import { fetchMediationsOptions } from '@/entities/mediation/api/fetchMediationsOptions.ts';
import { MediationStatus } from '@/entities/mediation/model/types.ts';

export const Route = createFileRoute('/_layout/cabinet/applications')({
  component: ApplicationsPage,
  validateSearch: (search: Record<string, unknown>) => {
    const shouldOpenApplication =
      search.shouldOpenApplication === true ||
      search.shouldOpenApplication === 'true';

    return {
      shouldOpenApplication,
    };
  },
  loaderDeps: ({ search }) => ({
    shouldOpenApplication: search.shouldOpenApplication,
  }),
  loader: async ({ deps }) => {
    const { shouldOpenApplication } = deps;

    const response = await queryClient.fetchQuery(fetchMediationsOptions());
    const firstMediation = response.data.mediations?.[0];
    const mediationId = firstMediation?.id;
    const pendingSign = firstMediation?.status === MediationStatus.Pending;

    if (shouldOpenApplication && mediationId && pendingSign) {
      throw redirect({
        to: '/application',
        search: { mediationId },
      });
    }

    return response;
  },
});
